import { useCallback, useSyncExternalStore } from 'react';
import { NodeState, SelectionStore } from './SelectionStore';

export const useNodeState = (
  store: SelectionStore,
  id: string,
): NodeState | undefined => {
  const subscribe = useCallback(
    (listener: () => void) => store.subscribe(id, listener),
    [store, id],
  );

  const getSnapshot = useCallback(() => store.getNode(id), [store, id]);

  return useSyncExternalStore(subscribe, getSnapshot);
};
